import React from 'react';
import { Header } from '../components/Header';
import { ArticleContent } from '../components/ArticleContent';
import { TestimonialSidebar } from '../components/TestimonialSidebar';
export function AdvertorialPage() {
  return <div className="w-full bg-white" data-id="element-343">
      <Header data-id="element-344" />
      <div className="max-w-7xl mx-auto px-[15px] pt-2.5 md:px-4 md:py-8" data-id="element-345">
        <div className="flex gap-8" data-id="element-346">
          {/* Main Content */}
          <div className="flex-1 max-w-3xl" data-id="element-347">
            <ArticleContent data-id="element-348" />
          </div>
          {/* Testimonial Sidebar - Desktop Only */}
          <div className="hidden lg:block w-80 flex-shrink-0" data-id="element-349">
            <TestimonialSidebar data-id="element-350" />
          </div>
        </div>
      </div>
    </div>;
}